//@flow
import type { Localization } from 'material-table';

export const localization: Localization = {
  body: { emptyDataSourceMessage: 'לא נמצאו תוצאות' },
  pagination: {
    nextTooltip: 'הבא',
    previousTooltip: 'הקודם',
    nextAriaLabel: 'הבא',
    previousAriaLabel: 'הקודם',
    labelDisplayedRows: '{from} עד {to} מתוך {count}',
    labelRowsSelect: 'שורות',
    firstAriaLabel: 'התחלה',
    firstTooltip: 'התחלה',
  },
  header: {
    actions: 'פעולות',
  },
  toolbar: {
    searchPlaceholder: 'חיפוש',
    searchTooltip: 'חיפוש 2',
  },
};
